import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'; // 1. Import the hook
import './VideoCarousel.css';

// Import your videos
import Vid1 from '../assets/video/sigiriya.mp4';
import Vid2 from '../assets/video/ambulu.mp4';
import Vid3 from '../assets/video/eleph.mp4';
import Vid4 from '../assets/video/galle.mp4';
import Vid5 from '../assets/video/see.mp4';
import Vid6 from '../assets/video/sri pade.mp4';
import Vid7 from '../assets/video/ella.mp4';

// 2. The data structure now holds translation KEYS instead of hardcoded text
const slidesData = [
  {
    src: Vid1,
    headlineKey: "slide1_headline",
    subHeadlineKey: "slide1_subHeadline",
    buttonTextKey: "slide1_buttonText",
  },
  {
    src: Vid2,
    headlineKey: "slide2_headline",
    subHeadlineKey: "slide2_subHeadline",
    buttonTextKey: "slide2_buttonText",
  },
  {
    src: Vid7,
    headlineKey: "slide3_headline",
    subHeadlineKey: "slide3_subHeadline",
    buttonTextKey: "slide3_buttonText",
  },
  {
    src: Vid3,
    headlineKey: "slide4_headline",
    subHeadlineKey: "slide4_subHeadline",
    buttonTextKey: "slide4_buttonText",
  },
  {
    src: Vid4,
    headlineKey: "slide5_headline",
    subHeadlineKey: "slide5_subHeadline",
    buttonTextKey: "slide5_buttonText",
  },
  {
    src: Vid6,
    headlineKey: "slide6_headline",
    subHeadlineKey: "slide6_subHeadline",
    buttonTextKey: "slide6_buttonText",
  },
  {
    src: Vid5,
    headlineKey: "slide7_headline",
    subHeadlineKey: "slide7_subHeadline",
    buttonTextKey: "slide7_buttonText",
  },
];

const VideoCarousel = () => {
  const { t } = useTranslation(); // Initialize the translation function
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      const nextIndex = (currentIndex + 1) % slidesData.length;
      setCurrentIndex(nextIndex);
    }, 8000);

    return () => clearTimeout(timer);
  }, [currentIndex]);

  return (
    <div className="video-carousel">
      <div
        className="video-slider"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {slidesData.map((slide, index) => (
          <div className="video-slide" key={index}>
            <video
              src={slide.src}
              autoPlay
              loop
              muted
              playsInline
              key={slide.src}
            />
            <div 
              className={`slide-content ${currentIndex === index ? 'active' : ''}`}
            >
              {/* 3. Use the t() function with the keys from our slidesData array */}
              <h2>{t(slide.headlineKey)}</h2>
              <p>{t(slide.subHeadlineKey)}</p>
              <button
                onClick={() => window.location.href = '/about'}
                className="explore-button"
              >
                {t(slide.buttonTextKey)}
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className="carousel-dots">
        {slidesData.map((_, index) => (
          <div
            key={index}
            className={`dot ${currentIndex === index ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default VideoCarousel;